import { c as _c } from "react/compiler-runtime";
import { Icon, IconName, IconSize } from '@sbt-web/ui';
import Labels from '../../Labels';
import classes from './index.module.scss';
export function FormSuccess() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={classes["abuse-success-wrapper"]}><Icon name={IconName.CheckCircle} iconSize={IconSize.LG} classes={[classes["icon-check"]]} /><h5 className="headline-5">{Labels.FORM.success.title}</h5><p className="caption book">{Labels.FORM.success.details}</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}